module.exports = __webpack_public_path__ + "static/ayanbadejo-db66d834a14662e3e42b866b8d8b66cc.jpg";